function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  fill: "#ffffff",
  stroke: "#DEDEDE",
  x: 172.5,
  y: 65.5,
  width: 95,
  height: 71
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "#DEDEDE",
  fillRule: "nonzero",
  x: 172,
  y: 65,
  width: 95,
  height: 10
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  fillRule: "nonzero",
  cx: 191,
  cy: 70,
  r: 2
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  fillRule: "nonzero",
  cx: 180,
  cy: 70,
  r: 2
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  fillRule: "nonzero",
  cx: 202,
  cy: 70,
  r: 2
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  stroke: "#073C50",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 112.5,
  y: 86.5,
  width: 139,
  height: 99
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  fill: "#073C50",
  fillRule: "nonzero",
  x: 112,
  y: 86,
  width: 140,
  height: 10
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  fillRule: "nonzero",
  cx: 131,
  cy: 91,
  r: 2
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  fillRule: "nonzero",
  cx: 120,
  cy: 91,
  r: 2
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  fillRule: "nonzero",
  cx: 142,
  cy: 91,
  r: 2
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M74.4536176,91.5055363 L75.0041404,93.7847007 C75.8777258,93.9736757 76.7304205,94.2879424 77.533002,94.7285713 L77.8738122,94.9251518 L79.8387088,93.6472022 L82.1558228,95.8997883 L80.9337344,97.8996409 C81.4323719,98.6734788 81.8064936,99.5052513 82.0556593,100.365744 L82.1547929,100.736199 L84.4488923,101.222231 L84.4944233,104.453627 L82.215647,105.004056 C82.0255614,105.877814 81.711174,106.730115 81.2709032,107.532729 L81.074504,107.873582 L82.3527576,109.838341 L80.1001868,112.15544 L78.0999101,110.933333 C77.3260721,111.432089 76.4942896,111.805681 75.6338027,112.055225 L75.2633504,112.154581 L74.7773607,114.448484 L71.5463886,114.494014 L70.9958612,112.214437 C70.1215981,112.025473 69.2699363,111.711214 68.4670992,111.270645 L68.1260919,111.074094 L66.1612913,112.351981 L63.8441772,110.099395 L65.066275,108.099527 C64.5675025,107.325668 64.1939005,106.493862 63.9443534,105.63335 L63.8449966,105.262887 L61.5511068,104.777294 L61.5055771,101.545996 L63.785512,100.995477 C63.9744891,100.121871 64.2887638,99.2691552 64.7294068,98.4665558 L64.9259937,98.1257381 L63.6476347,96.1608165 L65.8997978,93.8438005 L67.8999506,95.0662253 C68.6743515,94.5675839 69.5061721,94.1935075 70.3666941,93.9439334 L70.7371627,93.8445954 L71.2223564,91.5507379 L74.4536176,91.5055363 Z",
  stroke: "#073C50"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M73.1280703,98.0445029 C71.8706283,98.0445029 70.6145641,98.5330959 69.668866,99.5061396 C68.7586922,100.442748 68.3052319,101.653707 68.3043165,102.864199 C68.3034088,104.122531 68.7919889,105.380381 69.7654595,106.326963 C70.7030512,107.238118 71.9158235,107.692003 73.1276617,107.692003 C74.3851157,107.692003 75.6407464,107.203423 76.5864575,106.230367 C77.4965701,105.294277 77.9505001,104.082831 77.9514155,102.872307 C77.9523232,101.613975 77.4637431,100.356125 76.4902725,99.4095436 C75.5526809,98.4983886 74.3399085,98.0445029 73.1280703,98.0445029 Z",
  stroke: "#073C50"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M99.8128377,101.798703 L106.490933,102.524005 L106.956105,106.557037 C108.308791,107.077089 109.602841,107.778586 110.798219,108.657982 L114.444803,106.876305 L118.654696,112.11067 L116.132331,115.289836 C116.734806,116.645899 117.142834,118.060405 117.360635,119.493398 L121.200621,120.812755 L120.475995,127.490933 L116.442963,127.956105 C115.921559,129.308625 115.220146,130.602 114.341425,131.79746 L116.123778,135.444127 L110.889413,139.654021 L107.709571,137.131572 C106.353508,137.734048 104.939085,138.1414 103.50601,138.359876 L102.186652,142.199862 L95.5091498,141.475319 L95.0440607,137.441611 C93.6906992,136.921476 92.3980004,136.220146 91.2019468,135.340666 L87.5553632,137.122344 L83.3454696,131.887978 L85.8678349,128.708813 C85.2653596,127.352749 84.8580074,125.938327 84.6395309,124.505251 L80.7994617,123.186569 L81.5240883,116.508391 L85.5584717,116.043385 C86.0785241,114.690699 86.7800203,113.396649 87.6594165,112.201271 L85.8770634,108.554604 L91.1107533,104.344628 L94.2905115,106.867752 C95.6472508,106.26536 97.0617562,105.857332 98.4948321,105.638855 L99.8128377,101.798703 Z M96.7215074,116.192996 C95.2014433,117.416036 94.3085666,119.129042 94.0868262,120.923768 C93.8563809,122.789452 94.3518107,124.743576 95.6229513,126.324425 C96.8471768,127.846006 98.5628033,128.739891 100.359723,128.960525 C102.224221,129.189456 104.174966,128.693612 105.75438,127.422981 C107.274361,126.200617 108.167996,124.487018 108.389736,122.692292 C108.620182,120.826608 108.124752,118.872484 106.853611,117.291635 C105.629386,115.770054 103.913759,114.87617 102.11684,114.655536 C100.252342,114.426604 98.300921,114.922366 96.7215074,116.192996 Z",
  fill: "#E2FCA4",
  fillRule: "nonzero"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  fill: "#ffffff",
  stroke: "#073C50",
  x: 153.5,
  y: 113.5,
  width: 23,
  height: 23
});

var _ref16 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  fillRule: "nonzero",
  points: "171.75 122.386 169.929 120.5 163.89 126.753 161.071 123.834 159.25 125.72 163.89 130.5"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  fill: "#073C50",
  fillRule: "nonzero",
  x: 153,
  y: 144,
  width: 24,
  height: 24
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M164.999986,162.312497 C168.210115,162.312497 170.812472,159.71014 170.812472,156.500011 C170.812472,153.289882 168.210137,150.687525 164.999986,150.687525 C161.789857,150.687525 159.1875,153.289859 159.1875,156.500011 C159.1875,159.710162 161.789857,162.312497 164.999986,162.312497 Z M168.534004,158.973348 L162.526626,152.966015 C164.172031,151.809249 166.516301,151.917556 168.049394,153.450602 C169.583311,154.984542 169.690015,157.329065 168.534004,158.973348 Z M161.950577,159.549419 C160.416661,158.01548 160.309956,155.670957 161.465967,154.026674 L167.473346,160.034007 C165.827964,161.190773 163.48367,161.082489 161.950577,159.549419 Z",
  fill: "#FFFFFF",
  fillRule: "nonzero"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  fill: "#ffffff",
  stroke: "#073C50",
  x: 185.5,
  y: 144.5,
  width: 23,
  height: 23
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  fill: "#073C50",
  fillRule: "nonzero",
  x: 192,
  y: 155,
  width: 10,
  height: 3
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  fill: "#ffffff",
  stroke: "#073C50",
  x: 185.5,
  y: 113.5,
  width: 23,
  height: 23
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  fillRule: "nonzero",
  points: "201.705 119.25 203.75 121.295 199.545 125.5 203.75 129.705 201.705 131.75 197.499 127.545 193.295 131.75 191.25 129.705 195.454 125.5 191.25 121.295 193.295 119.25 197.5 123.454"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M258,175 L284,175 C287.313708,175 290,172.313709 290,169 L290,149 C290,145.686291 287.313708,143 284,143 L264,143 C260.686292,143 258,145.686291 258,149 L258,175 L258,175 Z",
  fill: "#E2FCA4",
  fillRule: "nonzero"
});

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#5E8871",
  fillRule: "nonzero",
  points: "280 169 283.868 169 283.868 166 280 166"
});

var _ref25 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#5E8871",
  fillRule: "nonzero",
  points: "279.795 152.893 283.663 152.893 283.663 149.893 279.795 149.893"
});

var _ref26 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  fillRule: "nonzero",
  opacity: 0.503,
  points: "280 157 283.868 157 283.868 154 280 154"
});

var _ref27 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#5E8871",
  fillRule: "nonzero",
  points: "280 161 283.868 161 283.868 158 280 158"
});

var _ref28 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  fillRule: "nonzero",
  opacity: 0.503,
  points: "280 165 283.868 165 283.868 162 280 162"
});

var _ref29 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#5E8871",
  fillRule: "nonzero",
  points: "275 169 278.868 169 278.868 166 275 166"
});

var _ref30 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  fillRule: "nonzero",
  opacity: 0.503,
  points: "275 165 278.868 165 278.868 162 275 162"
});

var _ref31 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#5E8871",
  fillRule: "nonzero",
  points: "270 169 273.868 169 273.868 166 270 166"
});

var _ref32 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#5E8871",
  fillRule: "nonzero",
  points: "270 157 273.868 157 273.868 154 270 154"
});

var _ref33 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  fillRule: "nonzero",
  opacity: 0.503,
  points: "270 161 273.868 161 273.868 158 270 158"
});

var _ref34 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#5E8871",
  fillRule: "nonzero",
  points: "270 165 273.868 165 273.868 162 270 162"
});

var _ref35 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#5E8871",
  fillRule: "nonzero",
  points: "265 169 268.868 169 268.868 166 265 166"
});

var _ref36 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  fillRule: "nonzero",
  opacity: 0.503,
  points: "265 165 268.868 165 268.868 162 265 162"
});

var SvgArtVotingPower = function SvgArtVotingPower(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "350px",
    height: "250px",
    viewBox: "0 0 350 250",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArtVotingPower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/art-voting-power.cd0dfadc.svg";
export { ForwardRef as ReactComponent };